<template>
  <div class="right-main right-main-edit">
    <div class="class-edit-container">
      <el-form ref="form" :model="formData" label-width="150px">
        <el-form-item label="学校名称">
          <el-input
            v-model="agentInfo.school_name"
            class="edit-input c-red"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="城市地区">
          <el-select
            v-model="formData.province_code"
            placeholder="请选择省"
            class="area-select"
            @change="onSelectProvince"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.city_code"
            placeholder="请选择市"
            class="area-select"
            @change="onSelectCity"
          >
            <el-option
              v-for="item in cityList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.area_code"
            placeholder="请选择区"
            class="area-select"
          >
            <el-option
              v-for="item in areaList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级名称">
          <el-input v-model="formData.name" class="edit-input"></el-input>
          <template v-if="!formData.id">
            <el-input-number
              v-model="formData.num"
              :min="1"
              :max="500"
              class="input-num"
              placeholder="班级人数"
            ></el-input-number
            ><span class="class-num">（班级人数）</span>
          </template>
        </el-form-item>

        <el-form-item label="班级ID（自动生成）">
          <el-input
            v-model="formData.class_code"
            class="edit-input c-red"
            readonly=""
          ></el-input>
        </el-form-item>
        <el-form-item label="班级图片（130x130）">
          <el-upload
            class="avatar-uploader"
            :action="wxPicUploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="formData.class_img"
              :src="formData.class_img"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="save-but"
            >立即提交</el-button
          >
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { wxPicUploadUrl } from "@/config/env";
export default {
  name: "EditClass",
  data() {
    return {
      provinceList: [],
      cityList: [],
      areaList: [],
      wxPicUploadUrl: wxPicUploadUrl,
      formData: {},
      agentInfo: {},
    };
  },
  props: {
    form: Object,
  },
  created() {
    this.getAgentArea();
  },
  watch: {
    form: function name() {
      this.init();
    },
  },
  methods: {
    init() {
      this.formData = this.form;
      // if (this.formData.id > 0) {
      //   this.getCity(this.formData.province_code);
      //   this.getArea(this.formData.city_code);
      // }
    },
    getAgentArea() {
      this.getRequest("/wenjiaoopne/kc/user/getUserArea", {})
        .then((result) => {
          this.agentInfo = result.data;
          this.provinceList = this.agentInfo.province;
          this.cityList = this.agentInfo.city;
          this.areaList = this.agentInfo.area;
          // console.log(this.provinceList);
          this.init();
        })
        .catch(() => {});
    },
    // 获取省份
    getProvince() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-dict-by-dictid",
        appId: "100012",
        categoryId: "100016",
      })
        .then((result) => {
          this.loading.close();
          this.provinceList = result.data;
          this.init();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 获取市列表
    getCity(_code) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-arbitrarily-dict",
        appId: "100395",
        categoryId: "100016",
        code: _code,
        level: 2,
      }).then((result) => {
        this.cityList = result.data;
      });
    },
    // 获取区
    getArea(_code) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-arbitrarily-dict",
        appId: "100395",
        categoryId: "100016",
        code: _code,
        level: 3,
      }).then((result) => {
        this.areaList = result.data;
      });
    },
    // 选择省份触发事件
    onSelectProvince(v) {
      this.form.city_code = "";
      this.form.area_code = "";
      (this.cityList = []), (this.areaList = []);
      if (this.agentInfo.city && this.agentInfo.city.length > 0) {
        this.cityList = this.agentInfo.city;
      } else {
        this.getCity(v);
      }
    },
    // 选择市区触发事件
    onSelectCity(v) {
      this.form.area_code = "";
      this.areaList = [];
      if (this.agentInfo.area && this.agentInfo.area.length > 0) {
        this.areaList = this.agentInfo.area;
      } else {
        this.getArea(v);
      }
    },
    // 上传图片回调
    handleAvatarSuccess(res) {
      this.formData.class_img = res.data;
    },
    // 图片上传验证
    beforeAvatarUpload(file) {
      const isJPG = [
        "image/gif",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/pjpeg",
        "image/x-png",
        "image/bmp",
      ].indexOf(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG === -1) {
        this.$message.error(
          "上传头像图片只能是 JPG,GIF,JPEG,PNG,PJPEG,X_PNG,BMP 格式!"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG > -1 && isLt2M;
    },

    // 添加班级提交事件
    onSubmit() {
      if (
        !this.formData.province_code ||
        this.formData.province_code.trim() === ""
      ) {
        this.$message.error("省不能为空");
        return false;
      }
      if (!this.formData.city_code || this.formData.city_code.trim() === "") {
        this.$message.error("市不能为空");
        return false;
      }
      if (!this.formData.area_code || this.formData.area_code.trim() === "") {
        this.$message.error("区不能为空");
        return false;
      }
      if (!this.formData.id || this.formData.id <= 0) {
        if (!this.formData.name || this.formData.name.trim() === "") {
          this.$message.error("班级名称不能为空");
          return false;
        }
      }

      if (this.formData.num <= 0 || this.formData.num > 500) {
        this.$message.error("班级人数不能超过1-500区间");
        return false;
      }
      this.onLoading();
      if (this.formData.id > 0) {
        this.postRequest("/wenjiaoopne/kc/class/update", this.formData)
          .then((result) => {
            this.loading.close();
            this.$emit("submitCallBack", result);
          })
          .catch(() => {
            this.loading.close();
          });
      } else {
        this.postRequest("/wenjiaoopne/kc/class/create", this.formData)
          .then((result) => {
            this.loading.close();
            this.$emit("submitCallBack", result);
          })
          .catch(() => {
            this.loading.close();
          });
      }
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>

<style scoped>
.class-edit-container {
  padding: 50px 50px 30px 50px;
}
.class-edit-container .area-select {
  width: 200px;
  margin-right: 10px;
}
.class-edit-container .edit-input {
  width: 300px;
}
.class-num {
  color: #8c939d;
  margin-left: 10px;
}
.class-edit-container .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #fff;
}
.class-edit-container .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.class-edit-container .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.class-edit-container .avatar {
  width: 130px;
  height: 130px;
  display: block;
}
.class-edit-container .save-but {
  background-color: #5abff0;
}
.input-num {
  margin-left: 10px;
}
</style>
